/*
 * File: /src/helpers/file-download-helper.js
 * Project: air-fields-shopify-frontend
 * -
 * File Created: Wednesday, 8th August 2018 5:11:50 pm
 * Last Modified: Wednesday, 8th August 2018 5:12:36 pm
 * Last Modified by: Bart
 * -
 * @author: Bart
 */

export default ({ data, filename }) => {
    let blob = new Blob([JSON.stringify(data)])
    let link = document.createElement('a')
    let url = window.URL.createObjectURL(blob)
    link.href = url
    link.download = filename
    link.dispatchEvent(new MouseEvent(`click`, {bubbles: true, cancelable: true, view: window}))
}


// WEBPACK FOOTER //
// ./src/helpers/file-download-helper.js